import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Ohio Healthy",
  shortName: "Ohio Healthy",
  slug: "ohio-healthy-insurance",
  seoTitle: "Ohio Healthy TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Ohio Healthy insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Ohio Healthy plan in Coral Springs, FL.",
  seoKeywords:
    "Ohio Healthy TMS coverage, Ohio Healthy TMS therapy, Ohio Healthy depression treatment Florida, Ohio Healthy mental health benefits Coral Springs FL, Ohio Healthy SAINT TMS",
  planType: "health insurance plan",
  planRegion: "Ohio",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Ohio Healthy provides health insurance coverage to members across Ohio. Ohio Healthy plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Coverage for TMS, accelerated TMS protocols, and other advanced depression treatments varies by individual plan — your specific policy type, network status, and documented prior treatment history all factor into the determination.",
  officialResourceUrl: "https://www.ohiohealthy.com/",
  officialResourceLabel: "Ohio Healthy official website",
};

export const OhioHealthyInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default OhioHealthyInsurance;
